import api from '@pray/shared/utils/api';

export async function updateOffer({
  artistId = undefined,
  offerId = undefined,
  title = undefined,
  description = undefined,
  pdfUrl = undefined,
  coverImageUrl = undefined,
  thumbnailUrl = undefined,
  fileSize = undefined,
  status = undefined,
}) {
  if (!offerId) throw new Error('Offer ID is required');

  const data = {
    artist_id: artistId,
  };

  if (title !== undefined) data.title = title;
  if (description !== undefined) data.description = description;
  if (pdfUrl !== undefined) data.pdf_url = pdfUrl;
  if (coverImageUrl !== undefined) data.cover_image_url = coverImageUrl;
  if (thumbnailUrl !== undefined) data.thumbnail_url = thumbnailUrl;
  if (fileSize !== undefined) data.file_size = fileSize;
  if (status !== undefined) data.status = status;

  const url = `/web/studio/offers/${offerId}`;
  const response = await api.executePutRequest(url, data);

  return response.data;
}
